<template>
  <div class="do-lot">
    <div class="lot-nav">
      <go-back
        class="go-back"
      ></go-back>
      <span
        class="item fs16 font333 pointer"
      >{{$t('withgold.LotsCompleted')}}</span>
    </div>
    <div class="page-content">
      <div class="page-box">
        <div class="vs-table-outer">
          <vs-table :noDataText="$t('root.noData')" :data="listData">
            <template
              slot="thead">
              <vs-th>
                {{$t('Trade.orderNo')}}
              </vs-th>
              <vs-th>
                {{$t('transaction_account')}}
              </vs-th>
              <vs-th>
                {{$t('User.reportCmd')}}
              </vs-th>
              <vs-th>
                {{$t('Trading_symbol')}}
              </vs-th>

              <vs-th>
                {{$t('Lot')}}
              </vs-th>
              <vs-th>
                {{$t('Opening_time')}}
              </vs-th>
              <vs-th>
                {{$t('Opening_price')}}
              </vs-th>
              <vs-th>
                {{$t('User.reportCloseTime')}}
              </vs-th>

              <vs-th>
                {{$t('User.reportClosePrice')}}
              </vs-th>
              <vs-th>
                {{$t('commission')}}
              </vs-th>
              <vs-th>
                {{$t('Inventory_fee')}}
              </vs-th>
              <vs-th>
                {{$t('User.reportProfit')}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(tr, index) in data" >
                <vs-td>
                  {{tr.order}}
                </vs-td>
                <vs-td>
                  {{$route.query.login}}
                </vs-td>

                <vs-td>
                  <span>{{tr.cmd  % 2 == 0 ? phFileter('User.buy') : phFileter('User.sell')}}</span>
                </vs-td>

                <vs-td>
                  {{tr.symbol}}
                </vs-td>
                <vs-td>
                  {{tr.volume}}
                </vs-td>
                <vs-td>
                  {{parseTime(tr.openTime)}}
                </vs-td>
                <vs-td>
                  {{tr.openPrice || '-'}}
                </vs-td>
                <vs-td>
                  {{parseTime(tr.closeTime)}}
                </vs-td>
                <vs-td>
                  {{tr.closePrice || '-'}}
                </vs-td>
                <vs-td>
                  {{tr.commission}}
                </vs-td>
                <vs-td>
                  {{tr.storage}}
                </vs-td>
                <vs-td>
                  <span>{{tr.profit}}</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="pagination-outer" v-if="total">
          <div class="paginnation-left">
            <size-change @sizeChange="sizeChange"></size-change>
            <span class="tatol-count">{{$t('total')}}&nbsp;{{total}}&nbsp;{{$t('item')}}</span>
          </div>
          <vs-pagination
            class="pagination-box"
            :max="max"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {parseTime} from "@/utils";
import { mapGetters } from 'vuex'
import initData from "@/mixins/initData";
export default {
  name: "index",
  components: {
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted(){
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
    this.init();
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    reouterview && reouterview.classList.remove('no-padding-import');
  },
  methods: {
    parseTime,
    phFileter(data){
      return this.$t(data)
    },
    beforeInit(){
      this.url = '/crm/reception/queryOrderByRecordId';
      this.params = {
        page: this.page - 1,
        size: this.size,
        id:this.$route.params.id,
      }
      return true;
    },
    getType(giveType){
      return giveType == 1 ? this.$t('User.credit') : this.$t('User.commissionBanlance');
    },
    getSuccessNumber(row){
      if(row.giveType == 2){
        return '---'
      }else {
        return row.successNumber / 100;
      }
    },
    getCompleteNumber(row){
      if(row.giveType == 2){
        return '---'
      }else {
        return row.completeNumber && row.completeNumber / 100;
      }
    },
    completeNumberHandle(row){
      if(row.completeNumber <= 0) return;
      // 跳转的页面 todo
      this.$router.push({name: 'completeLotsCloseOrder', query:{id: row.id}})
    },
    getEndTime(row){
      if(row.giveType == 2){
        return '---'
      }else {
        if(row.endTime){
          return this.parseTime(row.endTime);
        }else {
          return '-';
        }
      }
    },
    getCancleBtnShow(row){
      return row.giveType !==3 && (row.status == 5 || row.status == 3)
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    closeHandle(){
      this.transferDialogShow = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.do-lot {
  .lot-nav {
    height: 54px;
    line-height: 54px;
    padding-left: 2.2rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #ffffff;
    .go-back {
      margin-right: 10px;
    }
  }
  .page-content {
    padding: 24px;
    .page-box {
      background-color: #ffffff;
    }
  }
}
</style>
